import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { API_BASE_URL } from '../config';

const GoogleOAuthButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  // Get the redirect path from location state or default to '/'
  const from = location.state?.from?.pathname || '/';

  const handleSuccess = async (credentialResponse) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/auth/oauth/google`,
        {
          credential: credentialResponse.credential
        }
      );

      const {
        access_token,
        refresh_token,
        user_id,
        email,
        full_name,
        subscription_plan,
        is_new_user
      } = response.data;

      // Store tokens and user info
      localStorage.setItem('userEmail', email);
      if (full_name) {
        localStorage.setItem('userName', full_name);
      }

      login(access_token, refresh_token, {
        id: user_id,
        email,
        full_name,
        subscription_plan
      });

      // Redirect to the page user was trying to access, or home
      navigate(from, { replace: true });

      if (is_new_user) {
        console.log('Welcome! New account created via Google.');
      }
    } catch (error) {
      console.error('Google OAuth error:', error);
      alert(error.response?.data?.detail || 'Google login failed. Please try again.');
    }
  };

  const handleError = () => {
    console.error('Google Login Failed');
    alert('Google login failed. Please try again.');
  };

  return (
    <GoogleLogin
      onSuccess={handleSuccess}
      onError={handleError}
      useOneTap={false}
      theme="outline"
      size="large"
      text="continue_with"
      shape="rectangular"
      width="100%"
    />
  );
};

export default GoogleOAuthButton;
